export const TEST = 'TEST';
export const SET_VALUE = 'SET_VALUE';
export const SEND_PUSH = 'SEND_PUSH';
export const IS_SAVING_PUSH = 'IS_SAVING';

export const ACCESS_RIGHT = "ACCESS_RIGHT";
export const AUDIT_TRAIL = "AUDIT_TRAIL";
export const MEMBER_TOKEN = "MEMBER_TOKEN";
export const LOGIN = "LOGIN";
export const NAVIGATION = "NAVIGATION";
export const NOTIFICATION_SET_VALUE = "NOTIFICATION_SET_VALUE";
export const NOTIFICATION_IS_SAVING_PUSH = "NOTIFICATION_IS_SAVING_PUSH";
export const VIP_NOTIFICATION_SET_VALUE = "VIP_NOTIFICATION_SET_VALUE";
export const VIP_NOTIFICATION_IS_SAVING_PUSH = "VIP_NOTIFICATION_IS_SAVING_PUSH";
export const USER_SETUP = "USER_SETUP";
export const REDEMPTION_SUMMARY = "REDEMPTION_SUMMARY";
export const GENERATE_PROMOCODE = "GENERATE_PROMOCODE";
export const SEGMENTED_PUSH = "SEGMENTED_PUSH";
export const EVOUCHER = "EVOUCHER";
export const EVSCANNER = "EVSCANNER";
export const REPORTS = "REPORTS";
export const EVOUCHER_UPDATE_LOGS = "EVOUCHER_UPDATE_LOGS";
export const PENDING_NOTIFICATION = "PENDING_NOTIFICATION";
export const NOTIFICATION_HISTORY = "NOTIFICATION_HISTORY";
export const SCHEDULED_NOTIFICATION = "SCHEDULED_NOTIFICATION";
export const CAMPAIGN_CATEGORY = "CAMPAIGN_CATEGORY";
export const CUSTOM_BLOCK_MESSAGE = "CUSTOM_BLOCK_MESSAGE";
export const MOBILE_POS_SCAN_LOG = "MOBILE_POS_SCAN_LOG";
export const TIER_BLOCK_MESSAGE = "TIER_BLOCK_MESSAGE";
export const SET_BEACON = "SET_BEACON";
export const SET_EVOUCHER_CARD_TYPE = "SET_EVOUCHER_CARD_TYPE";
export const SET_EVOUCHER_PROMO_CATEGORY = "SET_EVOUCHER_PROMO_CATEGORY";
export const SET_APP_MENU = "SET_APP_MENU";
export const SET_CARD_IMAGES = "SET_CARD_IMAGES";
export const SET_KUMULOS = "SET_KUMULOS";
export const SET_MKIOSK_BANNER = "SET_MKIOSK_BANNER";
export const SET_LIFESTYLE_BANNER = "SET_LIFESTYLE_BANNER";
export const SET_POINTS_BANNER = "SET_POINTS_BANNER";
export const SET_SIGNUP_CONFIG = "SET_SIGNUP_CONFIG";
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_E_WALLET = 'SET_E_WALLET';
export const PHOENIXVOUCHER = 'PHOENIXVOUCHER';
export const SET_APP_THUMB = 'SET_APP_THUMB';


// WEBPACK FOOTER //
// ./actions/const.js